import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const SchemeManagement = lazy(() => import('../components/SchemeManagement'));

const SchemeManagementRoute: RouteObject = {
  path: 'scheme-management',
  element: <SchemeManagement />,
};

export default SchemeManagementRoute;
